/// REF: https://material-ui-next.com/style/color/
import cyan from '@material-ui/core/colors/cyan'
import blueGrey from '@material-ui/core/colors/blueGrey'

export const theme = {
  palette: {
    primary: {
      main: cyan[300],
      contrastText: '#fff'
    },
    secondary: {
      main: blueGrey[900],
      contrastText: '#fff'
    }
  },
  typography: {
    useNextVariants: true
  }
}

export const inverse = {
  palette: {
    primary: {
      main: blueGrey[900],
      contrastText: '#fff'
    },
    secondary: {
      main: cyan[300],
      contrastText: '#fff'
    }
  }
}

export const dark = {
  ...theme,
  palette: {
    type: 'dark'
  }
}
